import script from "./AppDrawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppDrawer.vue?vue&type=script&lang=ts&setup=true"

import "./AppDrawer.vue?vue&type=style&index=0&id=477530d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-477530d6"]])

export default __exports__